import {
  DELETE_FILTER_VEHICLE_TYPE,
  RESET_FILTER_VEHICLE_TYPE,
  SET_FILTER_VEHICLE_TYPE,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

export interface VehicleTypeFilterStateProps {
  vehicleType: string[];
  doors: string[];
  minSeats: number | null;
  maxSeats: number | null;
  filterCount: number;
}

export const InitialVehicleTypeFilterState: VehicleTypeFilterStateProps = {
  vehicleType: [],
  doors: [],
  minSeats: null,
  maxSeats: null,
  filterCount: 0,
};

const VehicleTypeFilterState = (
  state: VehicleTypeFilterStateProps = InitialVehicleTypeFilterState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_FILTER_VEHICLE_TYPE: {
      const newValues = {
        vehicleType: action.payload?.vehicleType ?? [],
        doors: action.payload?.doors ?? [],
        minSeats: action.payload?.minSeats ?? null,
        maxSeats: action.payload?.maxSeats ?? null,
      };

      return {
        ...newValues,
        filterCount:
          newValues.vehicleType.length +
          newValues.doors.length +
          (newValues.minSeats ? 1 : 0) +
          (newValues.maxSeats ? 1 : 0),
      };
    }
    case DELETE_FILTER_VEHICLE_TYPE: {
      const vehicleTypePayloadKey: keyof Omit<
        VehicleTypeFilterStateProps,
        'filterCount'
      > =
        (action.payload?.vehicleType && 'vehicleType') ||
        (action.payload?.doors && 'doors') ||
        (action.payload?.minSeats && 'minSeats') ||
        (action.payload?.maxSeats && 'maxSeats');

      const vehicleTypePayloadValue =
        action.payload?.vehicleType || action.payload?.doors;
      let vehicleTypeValues;

      if (
        vehicleTypePayloadKey === 'vehicleType' ||
        vehicleTypePayloadKey === 'doors'
      ) {
        const index =
          state[vehicleTypePayloadKey] &&
          state[vehicleTypePayloadKey].indexOf(vehicleTypePayloadValue);

        vehicleTypeValues = [
          ...state[vehicleTypePayloadKey].slice(0, index),
          ...state[vehicleTypePayloadKey].slice(index + 1),
        ];
      } else if (
        vehicleTypePayloadKey === 'minSeats' ||
        vehicleTypePayloadKey === 'maxSeats'
      ) {
        const filterCountToDecrease =
          state['minSeats'] && state['maxSeats'] ? 2 : 1;

        return {
          ...state,
          minSeats: undefined,
          maxSeats: undefined,
          filterCount: state.filterCount - filterCountToDecrease,
        };
      } else {
        vehicleTypeValues = undefined;
      }

      return {
        ...state,
        [vehicleTypePayloadKey]: vehicleTypeValues,
        filterCount: state.filterCount - 1,
      };
    }
    case RESET_FILTER_VEHICLE_TYPE:
      return InitialVehicleTypeFilterState;
    default:
      return state;
  }
};

export default VehicleTypeFilterState;
